import { render } from "./TableData.vue?vue&type=template&id=3c8bc66e&scoped=true"
import script from "./TableData.vue?vue&type=script&lang=js"
export * from "./TableData.vue?vue&type=script&lang=js"

import "./TableData.vue?vue&type=style&index=0&id=3c8bc66e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8bc66e"]])

export default __exports__